import '../about.css';

import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks/usePageTitle';

const AboutPage = () => {
    usePageTitle('About Us');
    return (
        <>
            <div className="about-page">

                {/* Page Header Section */}
                <section className="page-header">
                    <h1>📖 ABOUT US 📖</h1>
                    {/* Inline style for the green text as requested in the original HTML */}
                    <p style={{ color: '#66ff66', fontSize: '1.2rem' }}>
                        Learn about our mission and values
                    </p>
                    <Link to="/" className="back-button">
                        ← BACK TO HOME
                    </Link>
                </section>

                {/* Main Content Section - Mission and Values */}
                <section className="content-section">

                    {/* Mission Box */}
                    <div className="mission-box">
                        <h2>🎯 OUR MISSION</h2>
                        <p>
                            polira.site was created with a clear and important purpose: to provide safe, entertaining alternatives to real-money gambling. We believe that people should be able to enjoy the excitement and entertainment of casino-style games without risking their hard-earned money or financial stability.
                        </p>
                        <p>
                            Every day, thousands of people lose significant amounts of money to online gambling and casinos. Our platform exists to help prevent these losses by offering a completely free, risk-free environment where you can experience the same thrills without any financial consequences.
                        </p>
                        <p>
                            We're not just building games – we're building awareness. Through our platform, we hope to educate people about the realities of gambling and provide a healthy alternative for entertainment.
                        </p>
                    </div>

                    {/* Core Values Header */}
                    <h2
                        style={{
                            textAlign: 'center',
                            fontSize: '2.5rem',
                            marginBottom: '2rem',
                            textShadow: '0 0 15px #00ff00'
                        }}
                    >
                        ⭐ OUR CORE VALUES ⭐
                    </h2>

                    {/* Values Grid */}
                    <div className="values-grid">

                        <div className="value-card">
                            <div className="value-icon">🛡️</div>
                            <h3>SAFETY FIRST</h3>
                            <p>Your financial and mental wellbeing is our top priority. We never ask for money and never will.</p>
                        </div>

                        <div className="value-card">
                            <div className="value-icon">🎓</div>
                            <h3>EDUCATION</h3>
                            <p>We aim to educate users about responsible gaming and the real risks of gambling addiction.</p>
                        </div>

                        <div className="value-card">
                            <div className="value-icon">💚</div>
                            <h3>TRANSPARENCY</h3>
                            <p>We're honest about what we are – a platform with no real money involved, period.</p>
                        </div>

                        <div className="value-card">
                            <div className="value-icon">🌍</div>
                            <h3>ACCESSIBILITY</h3>
                            <p>Free entertainment for everyone, everywhere. No barriers, no fees, no restrictions.</p>
                        </div>

                        <div className="value-card">
                            <div className="value-icon">🎨</div>
                            <h3>QUALITY</h3>
                            <p>We create engaging, high-quality gaming experiences that rival real social casino platforms.</p>
                        </div>

                        <div className="value-card">
                            <div className="value-icon">🤝</div>
                            <h3>COMMUNITY</h3>
                            <p>Building a supportive community that values fun over financial risk.</p>
                        </div>
                    </div>
                </section>

                {/* Story Section */}
                <section className="story-section">
                    <div className="story-box">
                        <h2>📚 OUR STORY</h2>
                        <p>
                            polira.site was born from a simple observation: too many people were losing money they couldn't afford to lose in online social casino games and gambling platforms. As a frontend developer, I realized I could use my skills to create something that would help address this problem.
                        </p>
                        <p>
                            The concept is straightforward – create social casino experiences that are just as engaging and entertaining as real gambling sites, but without any financial risk. By offering free alternatives, we hope to satisfy the desire for entertainment while protecting people's finances.
                        </p>
                        <p>
                            This project is part of a 30-day development challenge where we're creating 30 different social casino games websites, each with unique themes and designs. The goal is to showcase that safe, responsible entertainment is possible and can be just as exciting as real gambling.
                        </p>
                        <p>
                            Every site in this series emphasizes the same core message: play for fun, not for money. Learn the games, enjoy the experience, but protect your wallet and your future.
                        </p>
                        <p>
                            We believe that by providing quality alternatives and raising awareness about gambling risks, we can make a real difference in people's lives. If even one person chooses our free platform over a real social casino games and saves their money, we've succeeded.
                        </p>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
}

export default AboutPage;